import { render, staticRenderFns } from "./groupAlarmHisAlarm.vue?vue&type=template&id=33d67636&scoped=true"
import script from "./groupAlarmHisAlarm.vue?vue&type=script&lang=js"
export * from "./groupAlarmHisAlarm.vue?vue&type=script&lang=js"
import style0 from "./groupAlarmHisAlarm.vue?vue&type=style&index=0&id=33d67636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d67636",
  null
  
)

export default component.exports